<template>
  <FormPanel
      headline="Create Article Flag"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentArticleFlags/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/content-article-flags', {...data, portal_id: this.portal.id})
          .then(() => {
            notify.success('The content article flag was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/article-flags')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
